import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TeamRow from './TeamRow';
import FairTxList from './FairTxList';

// Команда в табе «Команды» с раскрывающейся историей её покупок (команда как покупатель).
export default function TeamHistoryItem({ team, onAddBalance, onDelete, teamName, colorOf, pointName }) {
    const [open, setOpen] = useState(false);
    return (
        <div className="fr-teamwrap">
            <TeamRow team={team} onAddBalance={onAddBalance} onDelete={onDelete} expanded={open} onToggleHistory={() => setOpen(!open)} />
            {open && (
                <div className="fr-txpanel">
                    <FairTxList
                        queryKey={['fair', 'team-tx', team.id]}
                        url={`/api/fair/admin/transaction/list-by-team?teamStateId=${team.id}`}
                        teamName={teamName}
                        colorOf={colorOf}
                        pointName={pointName}
                    />
                </div>
            )}
        </div>
    );
}

TeamHistoryItem.propTypes = {
    team: PropTypes.object.isRequired,
    onAddBalance: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    teamName: PropTypes.func.isRequired,
    colorOf: PropTypes.func.isRequired,
    pointName: PropTypes.func
};

TeamHistoryItem.defaultProps = { pointName: null };
